import {FormioBase} from "./formiobase";

export class DateTime extends FormioBase {
  public inputType = "datetime";
  public title = "Date / Time";
  public icon = "fas fa-clock";
  public schema: any = {
    title: "datetime",
    components: [{
      input: true,
      inputType: "datetime",
      tableView: true,
      label: "DateTime",
      key: undefined,
      placeholder: "",
      format: "dd-MM-yyyy",
      enableDate: true,
      enableTime: true,
      defaultDate: "",
      datepickerMode: "day",
      allowCalculateOverride: true,
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRange: "20",
        datepickerMode: "day",
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true,
      },
      protected: false,
      persistent: true,
      validate: {
        required: false,
        custom: "",
        laterThanNow: false,
        olderThan: 0,
        laterThan: "",
        earlierThan: "",
      },
      type: "datetime",
      tags: [],
      disabled: false,
      description: "",
      tooltip: "",
      customClass: "ds-datetime",
    }],
  };
}
